import { ScenarioModel } from 'types/shared/scenario-model-type.enum';
import { CalibrationModel } from 'views/bluviu-nutrition/features/calibrations/types/calibration-model.enum';
import { FeedSource } from '../../../types/feed-source.enum';
import { ScenarioState } from '../../../types/scenario-state.enum';

export enum Currency {
  NOK = 'nok',
  USD = 'usd',
}

export interface Scenario {
  id: string;
  name: string;
  description: string;
  model: ScenarioModel; // is this still needed?
  state: ScenarioState;
  globalCompanyId: string;
  globalSiteId: string;
  siteName: string;
  latitude: number | null;
  longitude: number | null;
  currency: Currency;
  fishWeight: number;
  calibrationId: string;
  calibrationModel: CalibrationModel;
  startDate: string;
  endDate: string;
  feedPrograms: FeedProgram[];
  createdDate: string;
  updatedDate: string;
}

export interface FeedProgram {
  id: string;
  name: string;
  feeds: Feed[];
}

export interface Feed {
  fishSizeStart: number;
  feedId: string;
  price: number;
  feedSource: FeedSource;
  isActive: boolean;
  feedName: string;
}

/**
 * Used in the FeedProgram form for updating a Feed Program in a Scenario. Flattens a Feed and Feed Program into one object to easily use in Data Grid
 */
export interface AvailableFeedProgram {
  sizeStart: number;
  feedId: string;
  price: number;
  feedSource: FeedSource;
  programName: string;
  programId: string;
}
